import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./columns";
import ProductContextMenu from "./contextMenu/ProductContextMenu";

export function ProductTablePage() {
  return (
    <ServerDataGrid
      columns={columns}
      apiEndpoint="/datagrid/product"
      getRowId={(row) => row.product.product_id}
      getDeleteBlockReason={(row) =>
        row.product_asin_list_view?.asin_list
          ? "Product has associated Amazon listings"
          : undefined
      }
      ContextMenuComponent={ProductContextMenu}
      tableName="product"
      enableSearch={true}
      pageSizeOptions={[25, 50, 100, 250, 500]}
      height={"calc(100vh - 52.6px)"}
      initialStateOverride={{
        sorting: { sortModel: [{ field: "product.created_at", sort: "desc" }] },
      }}
    />
  );
}
